import styled from 'styled-components';

export const BGWrap = styled.div`
  width: 100%;
  padding-top: ${({ width, height }) => `${(height / width) * 100}%`};
  /* border: 1px solid #f2f2f2; */
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
  position: relative;
  
  > div {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`;

export const Youtube = styled.div`
  width: 94.65%;
  height: 87.94%;
  margin: auto;
  
  > div {
    width: 100%;
    height: 100%;
  }
  
  iframe {
    width: 100%;
    height: 100%;
  }
`;

export const Btn = styled.button`
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  position: absolute;
  top: 42.45%;
  left: 18.87%;
  right: 18.87%;
  bottom: 21.58%
`;
